import React, { useEffect } from "react";
import "./index.scss";
import NOT_FOUND_IMG from "../../resources/images/not-found.png";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const navigate = useNavigate();
  useEffect(() => {
    setTimeout(() => {
      navigate("/");
    }, 1000);
  }, []);
  return (
    <div className="not-found-con">
      <div className="error-message-con">
        <p className="error-heading">Error 404!</p>
        <p className="sub-heading">
          The Page you are navigating might doesn't exists
        </p>
        <Button onClick={() => navigate("/")}>Go Back Home</Button>
      </div>
      <img src={NOT_FOUND_IMG} alt="Not Found" />
    </div>
  );
};

export default NotFound;
